/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerErrors } from './get-draft-payment-request200-response-evidences-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerFile } from './get-draft-payment-request200-response-evidences-inner-file';
// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer } from './get-draft-payment-request200-response-evidences-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy } from './get-draft-payment-request200-response-evidences-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy } from './get-draft-payment-request200-response-evidences-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetDraftPaymentRequest200ResponseEvidencesInnerWarnings } from './get-draft-payment-request200-response-evidences-inner-warnings';

/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInner
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInner {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'paymentType': GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'electronicMethod': GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'documentSize': GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'legalValidity': GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerFile}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'file': GetDraftPaymentRequest200ResponseEvidencesInnerFile;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'invoiceIssuer': GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerErrors}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'errors': GetDraftPaymentRequest200ResponseEvidencesInnerErrors;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerWarnings}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'warnings': GetDraftPaymentRequest200ResponseEvidencesInnerWarnings;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'updatedBy': GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'uploadedBy': GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'needsMigration'?: boolean;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum];


